// Re-uses AdminSupport component which already has full ticket management
import AdminSupport from "@/pages/admin/AdminSupport";

const SupportTickets = () => {
  return <AdminSupport />;
};

export default SupportTickets;
